<template>
    <el-card class="box-card">
        <el-row>
            <SearchBox ref="SearchBox">
                <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="100px"
                         class="unitWidth" size="small">
                    <el-form-item label="所属工厂">
                        <el-select v-model="mechanism.fcCode" placeholder="请选择" :clearable="isclear" :disabled="ischeck"
                                   filterable @change="fcChange">
                            <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label"
                                       :value="factory.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属车间">
                        <el-select v-model="mechanism.shopCode" placeholder="请选择" clearable filterable
                                   @change="shopChange">
                            <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label"
                                       :value="shop.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属工段">
                        <el-select v-model="mechanism.sectionCode" placeholder="请选择" clearable filterable
                                   @change="sectionChange">
                            <el-option v-for="section in sectionList" :key="section.value" :label="section.label"
                                       :value="section.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属产线">
                        <el-select v-model="mechanism.lineCode" placeholder="请选择" clearable filterable
                                   @change="lineChange">
                            <el-option v-for="line in lineList" :key="line.value" :label="line.label"
                                       :value="line.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="排序维度">
                        <el-select clearable v-model="searchParams.sortSelected" clearable>
                            <el-option value="sumCount" label="次数">次数</el-option>
                            <el-option value="responseTime" label="响应时长">响应时长</el-option>
                            <el-option value="avgResponseTime" label="平均响应时长">平均响应时长</el-option>
                            <el-option value="repairTime" label="系统记录维修时长">系统记录维修时长</el-option>
                            <el-option value="probTime" label="故障总时长">故障总时长</el-option>
                            <!--<el-option value="twoRate" label="两小时修复率">两小时修复率</el-option>-->
                            <!--<el-option value="MTBF" label="MTBF">MTBF</el-option>
                            <el-option value="MTTR" label="MTTR">MTTR</el-option>-->
                        </el-select>
                    </el-form-item>
                    <el-form-item label="维修人">
                        <el-input clearable v-model="searchParams.andonRespUserName"></el-input>
                    </el-form-item>
                    <!--<el-form-item label="工单状态">
                    <el-select clearable v-model="searchParams.andonStatus" clearable>
                        <el-option value="create" label="待接单">待接单</el-option>
                        <el-option value="wait_complete" label="待完成">待完成</el-option>
                        <el-option value="wait_accept" label="待验收">待验收</el-option>
                        <el-option value="complete" label="已完成">已完成</el-option>
                    </el-select>
                </el-form-item>-->
                    <el-form-item label="角色名称">
                        <el-select v-model="searchParams.roleId" placeholder="请选择" clearable filterable>
                            <el-option v-for="role in roleList" :key="role.roleId" :label="role.roleName"
                                       :value="role.roleId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择日期">
                        <el-date-picker
                            style="width: 20vw"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            v-model="dataTime"
                            transfer
                            @change="getStatistics"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            show-week-numbers
                            placement="bottom-end"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item style="margin-left: 20px">
                        <el-button type="primary" @click="getStatistics">查询</el-button>
                        <el-button type="primary" @click="exportPersonnelStatistics" style="margin-left: 10px">导出
                        </el-button>
                    </el-form-item>
                </el-form>
            </SearchBox>
        </el-row>
        <el-row>
            <el-tabs type="border-card">
                <el-tab-pane label="人员信息">
                    <div class="tableBox">
                        <el-table stripe ref="multipleTable" :data="twoAnalyze" class="center"
                                  @selection-change="handleSelectionChange" @sort-change="sortChange">
                            <el-table-column prop="andonRespUserName" sortable label="维修人"/>
                            <el-table-column prop="roleName" sortable label="角色" show-overflow-tooltip/>
                            <el-table-column prop="sumCount" sortable label="次数"/>
                            <el-table-column prop="responseTime" sortable label="响应时长(分)" width="130"/>
                            <el-table-column prop="avgResponseTime" sortable label="平均响应时长(分)" width="160"/>
                            <el-table-column prop="mainResponseTime" sortable label="系统记录维修时长(分)" width="190"/>
                            <el-table-column prop="toFResponseTime" sortable label="故障总时长(分)" width="140"/>
                            <!--<el-table-column prop="mtbf" sortable label="MTBF(分)" />
                            <el-table-column prop="mttr" sortable label="MTTR(分)" />-->
                        </el-table>
                    </div>
                    <el-pagination
                        @size-change="paginationChange"
                        @current-change="paginationCurrentChange"
                        :current-page="searchParams.pageNumber"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="searchParams.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="searchParams.total"
                    />
                    <!--<table id="mytable">
                    <thead>
                    <tr>
                        <th>报修人</th>
                        <th>次数</th>
                        <th>响应时长(分)</th>
                        <th>平均响应时长(分)</th>
                        <th>系统记录维修时长(分)</th>
                        <th>故障总时长(分)</th>
                        &lt;!&ndash;<th>两小时修复率</th>&ndash;&gt;
                        <th>MTBF</th>
                        <th>MTTR</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(order, index) in twoAnalyze">
                        <td>{{ order.pubUserName }}</td>
                        <td>{{ order.sumCount }}</td>
                        <td>{{ order.responseTime != null ? String(parseFloat(order.responseTime) / 60).substring(0,
                            String(parseFloat(order.responseTime) / 60).indexOf('.') + 3) : '0' }}
                        </td>
                        <td>
                            {{
                            order.responseTime != null
                            ? String(parseFloat(order.responseTime) / 60 / order.sumCount).substring(0,
                            String(parseFloat(order.responseTime) / 60 / order.sumCount).indexOf('.') + 3)
                            : '0'
                            }}
                        </td>
                        <td>{{ String(parseFloat(order.repairTime) / 60).substring(0,
                            String(parseFloat(order.repairTime) / 60).indexOf('.') + 3) }}
                        </td>
                        <td>{{ String(parseFloat(order.probTime) / 60).substring(0,
                            String(parseFloat(order.probTime) / 60).indexOf('.') + 3) }}
                        </td>
                        &lt;!&ndash;<td>
                            {{
                                order.recoveryCount != null
                                    ? String((parseFloat(order.recoveryCount)/parseFloat(order.sumCount)*100).toFixed(2))+'%'
                                    : '0'

                            }}
                        </td>&ndash;&gt;
                        <td>
                            {{
                            String((parseFloat(order.totalTime) / 60 / parseFloat(order.sumCount)).toFixed(2))

                            }}
                        </td>
                        <td>
                            {{
                            String((parseFloat(order.repairTime) / 60 / parseFloat(order.sumCount)).toFixed(2))

                            }}
                        </td>
                    </tr>
                    </tbody>
                </table>-->
                </el-tab-pane>
                <el-tab-pane label="图表">
                    <div id="main"></div>
                </el-tab-pane>
            </el-tabs>
        </el-row>
    </el-card>
</template>
<script>
    import { getPersonnelStatistics } from '../../../api/reportform.js'
    import { exportPersonnelStatistics } from '../../../libs/api'

    const { export_json_to_excel } = require('../../vendor_excel/Export2Excel')
    // 引入基本模板
    let echarts = require('echarts/lib/echarts')
    // 引入柱状图组件
    require('echarts/lib/chart/bar')
    // 引入提示框和title组件
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')
    require('echarts/lib/component/legend')

    export default {
        name: 'personnelReport',
        data: function() {
            return {
                mechanism: {
                    fcCode: '',
                    shopCode: '',
                    sectionCode: '',
                    lineCode: ''
                },
                searchParams: {
                    pageSize: 10,
                    pageNumber: 1,
                    total: 0,
                    fcCode: '',
                    shopCode: '',
                    sectionCode: '',
                    lineCode: '',
                    sortSelected: '',
                    sort: '',
                    number: '',
                    startTime: '',
                    endTime: '',
                    pubUserName: '',
                    andonStatus: '',
                    roleId: '',
                    andonRespUserName: ''

                },
                isclear: false,
                factoryData: [],
                access: [],
                role: [],
                ischeck: true,
                scopeDisabled: '',
                factoryTree: [],
                addShow: false,
                userInfo: {},
                fcIdSelected: '',
                twoAnalyze: [],
                dataTime: [],
                excelData: [],
                roleList: []
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.mechanism.fcCode != undefined && this.mechanism.fcCode.length > 0) {

                    var factory = JSON.parse(this.mechanism.fcCode)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.mechanism.shopCode != undefined && this.mechanism.shopCode.length > 0) {
                    var shop = JSON.parse(this.mechanism.shopCode)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.mechanism.sectionCode != undefined && this.mechanism.sectionCode.length > 0) {
                    var vsm = JSON.parse(this.mechanism.sectionCode)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init: function() {
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.scopeDisabled = false
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getFactory()
                this.getData()
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.getStatistics()
            },
            paginationCurrentChange(val) {
                this.searchParams.pageNumber = val
                this.getStatistics()
            },
            fcChange() {
                this.mechanism.shopCode = ''
                this.mechanism.sectionCode = ''
                this.mechanism.lineCode = ''
                this.searchParams.roleId = ''
                this.getRoles()
                this.getStatistics()
            },
            shopChange() {
                this.mechanism.sectionCode = ''
                this.mechanism.lineCode = ''
                this.getStatistics()
            },
            sectionChange() {
                this.mechanism.lineCode = ''
                this.getStatistics()
            },
            lineChange() {
                this.getStatistics()
            },
            getRoles() {
                var params = {}
                if (this.mechanism.fcCode != undefined && this.mechanism.fcCode != '') {
                    params['fcCode'] = JSON.parse(this.mechanism.fcCode).deptCode
                } else {
                    return
                }
                let options = {
                    method: 'GET',
                    url: this.$api.listRole,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.roleList = []
                        if (this.ischeck == false) {
                            this.roleList = response.data
                        } else {
                            var aa = response.data
                            for (let i = 0; i < aa.length; i++) {
                                if (aa[i].roleCode != 'admin') {
                                    this.roleList.push(aa[i])
                                }
                            }
                        }
                    }
                })
            },
            getFactory() {
                let queryParams = {
                    fcCode: this.userInfo.fcCode
                }
                let options = {
                    methods: 'GET',
                    url: this.$api.getAllFactory,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryData = response.data
                    }
                })
            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.mechanism.fcCode = JSON.stringify(self.factoryTree[i])
                        }
                    }
                    this.getRoles()
                    this.getStatistics()
                })
            },
            getdatarange() {

                if (this.dataTime.length > 0 && this.dataTime[0] != '' && this.dataTime[1] != '') {
                    this.searchParams.startTime = this.dataTime[0]
                    this.searchParams.endTime = this.dataTime[1]
                }
                this.dateRange = this.data
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            async exportPersonnelStatistics() {
                var self = this
                self.searchParams.fcCode = ''
                self.searchParams.shopCode = ''
                self.searchParams.sectionCode = ''
                self.searchParams.lineCode = ''
                if (self.mechanism.fcCode != undefined && self.mechanism.fcCode != '') {
                    self.searchParams.fcCode = JSON.parse(self.mechanism.fcCode).deptCode
                }
                if (self.mechanism.shopCode != undefined && self.mechanism.shopCode != '') {
                    self.searchParams.shopCode = JSON.parse(self.mechanism.shopCode).deptCode
                }
                if (self.mechanism.sectionCode != undefined && self.mechanism.sectionCode != '') {
                    self.searchParams.sectionCode = JSON.parse(self.mechanism.sectionCode).deptCode
                }
                if (self.mechanism.lineCode != undefined && self.mechanism.lineCode != '') {
                    self.searchParams.lineCode = JSON.parse(self.mechanism.lineCode).deptCode
                }
                if (self.dataTime != null && self.dataTime != '') {
                    if (self.dataTime.length > 0 && self.dataTime[0] != '') {
                        self.searchParams.startTime = self.dataTime[0] + ' 00:00:00'
                        self.searchParams.endTime = self.dataTime[1] + ' 23:59:59'
                    }
                } else {
                    self.searchParams.startTime = ''
                    self.searchParams.endTime = ''
                }
                let options = {
                    method: 'POST',
                    data: self.searchParams,
                    url: this.$api.exportPersonnelStatistics,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = '人员报修统计'  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            },
            getStatistics() {
                var self = this
                self.twoAnalyze = []
                self.searchParams.fcCode = ''
                self.searchParams.shopCode = ''
                self.searchParams.sectionCode = ''
                self.searchParams.lineCode = ''
                if (self.mechanism.fcCode != undefined && self.mechanism.fcCode != '') {
                    self.searchParams.fcCode = JSON.parse(self.mechanism.fcCode).deptCode
                }
                if (self.mechanism.shopCode != undefined && self.mechanism.shopCode != '') {
                    self.searchParams.shopCode = JSON.parse(self.mechanism.shopCode).deptCode
                }
                if (self.mechanism.sectionCode != undefined && self.mechanism.sectionCode != '') {
                    self.searchParams.sectionCode = JSON.parse(self.mechanism.sectionCode).deptCode
                }
                if (self.mechanism.lineCode != undefined && self.mechanism.lineCode != '') {
                    self.searchParams.lineCode = JSON.parse(self.mechanism.lineCode).deptCode
                }
                if (self.dataTime != null && self.dataTime != '') {
                    if (self.dataTime.length > 0 && self.dataTime[0] != '') {
                        self.searchParams.startTime = self.dataTime[0] + ' 00:00:00'
                        self.searchParams.endTime = self.dataTime[1] + ' 23:59:59'
                    }
                } else {
                    self.searchParams.startTime = ''
                    self.searchParams.endTime = ''
                }
                getPersonnelStatistics(self.searchParams).then(function(resp) {
                    if (resp.status == 100) {
                        if (resp.data != undefined && resp.data != '') {
                            /*let list = resp.data.list
                            for (let i = 0; i < list.length; i++) {
                                let arrayList = {
                                    devCode: '',
                                    devName: '',
                                    sumCount: '',
                                    responseTime: '',
                                    avgResponseTime: '',
                                    mainResponseTime: '',
                                    toFResponseTime: '',
                                    MTBF: '',
                                    MTTR: ''
                                }
                                arrayList.devCode = list[i].devCode
                                arrayList.devName = list[i].devName
                                arrayList.sumCount = list[i].sumCount
                                arrayList.responseTime = list[i].responseTime != null ? String(parseFloat(list[i].responseTime) / 60)
                                        .substring(0, String(parseFloat(list[i].responseTime) / 60).indexOf('.') + 3) : '0'
                                arrayList.avgResponseTime = list[i].responseTime != null ? String(parseFloat(list[i].responseTime) / 60 / list[i].sumCount)
                                        .substring(0, String(parseFloat(list[i].responseTime) / 60 / list[i].sumCount).indexOf('.') + 3) : '0'
                                arrayList.mainResponseTime = String(parseFloat(list[i].repairTime) / 60)
                                    .substring(0, String(parseFloat(list[i].repairTime) / 60).indexOf('.') + 3)
                                arrayList.toFResponseTime = String(parseFloat(list[i].probTime) / 60)
                                    .substring(0, String(parseFloat(list[i].probTime) / 60).indexOf('.') + 3)
                                arrayList.MTBF = String((parseFloat(list[i].totalTime) / 60 / list[i].sumCount))
                                    .substring(0, String((parseFloat(list[i].totalTime) / 60 / list[i].sumCount)).indexOf('.') + 3)
                                arrayList.MTTR = String((parseFloat(list[i].repairTime) / 60 / list[i].sumCount))
                                    .substring(0, String((parseFloat(list[i].repairTime) / 60 / list[i].sumCount)).indexOf('.') + 3)
                                self.twoAnalyze.push(arrayList)
                            }*/
                            self.twoAnalyze = resp.data.list
                            self.searchParams.total = resp.data.total
                        } else {
                            self.twoAnalyze = []
                        }
                        var option = self.creatObject()
                        if (self.twoAnalyze == undefined || self.twoAnalyze == null) {
                            return
                        }
                        switch (self.searchParams.sortSelected) {
                            case 'devCode':
                                option.legend = {
                                    show: true,
                                    data: ['维修次数', '响应时长', '平均响应时长', '系统记录维修时长', '故障总时长'/*, '两小时修复率'*//*, 'MTBF', 'MTTR'*/],
                                    selected: {
                                        '维修次数': true,
                                        '响应时长': true,
                                        '平均响应时长': true,
                                        '系统记录维修时长': true,
                                        '故障总时长': true
                                        // '两小时修复率': true,
                                        /*'MTBF': true,
                                        'MTTR': true*/
                                    }
                                }
                                option.series = [
                                    { name: '维修次数', type: 'bar', data: [] },
                                    { name: '响应时长', type: 'bar', data: [] },
                                    { name: '平均响应时长', type: 'bar', data: [] },
                                    { name: '系统记录维修时长', type: 'bar', data: [] },
                                    { name: '故障总时长', type: 'bar', data: [] }
                                    // { name: '两小时修复率', type: 'bar', data: [] },
                                    /*{ name: 'MTBF', type: 'bar', data: [] },
                                    { name: 'MTTR', type: 'bar', data: [] }*/
                                ]
                                for (var i = 0; i < self.twoAnalyze.length; i++) {
                                    option.xAxis[0].data.push(self.twoAnalyze[i].andonRespUserName)
                                    option.series[0].data.push(self.twoAnalyze[i].sumCount)
                                    option.series[1].data.push(self.twoAnalyze[i].responseTime)
                                    option.series[2].data.push(self.twoAnalyze[i].avgResponseTime)
                                    option.series[3].data.push(self.twoAnalyze[i].mainResponseTime)
                                    option.series[4].data.push(self.twoAnalyze[i].toFResponseTime)
                                    // option.series[5].data.push(self.twoAnalyze[i].recoveryCount != null ? String((parseFloat(self.twoAnalyze[i].recoveryCount / self.twoAnalyze[i].sumCount) * 100).toFixed(2)) + '%' : '0')
                                    // option.series[5].data.push(self.twoAnalyze[i].mtbf)
                                    // option.series[6].data.push(self.twoAnalyze[i].mttr)
                                }
                                break
                            case 'sumCount':
                                option.legend = {
                                    show: true,
                                    data: ['维修次数'],
                                    selected: {
                                        '维修次数': true,
                                        '响应时长': false,
                                        '平均响应时长': false,
                                        '系统记录维修时长': false,
                                        '故障总时长': false,
                                        // '两小时修复率': false,
                                        'MTBF': false,
                                        'MTTR': false
                                    }
                                }
                                option.series = [{ name: '维修次数', type: 'bar', data: [] }]
                                for (var i = 0; i < self.twoAnalyze.length; i++) {
                                    option.xAxis[0].data.push(self.twoAnalyze[i].andonRespUserName)
                                    option.series[0].data.push(self.twoAnalyze[i].sumCount)
                                }
                                break
                            case 'responseTime':
                                option.legend = {
                                    show: true,
                                    data: ['响应时长'],
                                    selected: {
                                        '维修次数': false,
                                        '响应时长': true,
                                        '平均响应时长': false,
                                        '系统记录维修时长': false,
                                        '故障总时长': false,
                                        // '两小时修复率': false,
                                        'MTBF': false,
                                        'MTTR': false
                                    }
                                }
                                option.series = [{ name: '响应时长', type: 'bar', data: [] }]
                                for (var i = 0; i < self.twoAnalyze.length; i++) {
                                    option.xAxis[0].data.push(self.twoAnalyze[i].andonRespUserName)
                                    option.series[0].data.push(self.twoAnalyze[i].responseTime)
                                }
                                break
                            case 'avgResponseTime':
                                option.legend = {
                                    show: true,
                                    data: ['平均响应时长'],
                                    selected: {
                                        '维修次数': false,
                                        '响应时长': false,
                                        '平均响应时长': true,
                                        '系统记录维修时长': false,
                                        '故障总时长': false,
                                        // '两小时修复率': false,
                                        'MTBF': false,
                                        'MTTR': false
                                    }
                                }
                                option.series = [{ name: '平均响应时长', type: 'bar', data: [] }]
                                for (var i = 0; i < self.twoAnalyze.length; i++) {
                                    option.xAxis[0].data.push(self.twoAnalyze[i].andonRespUserName)
                                    option.series[0].data.push(self.twoAnalyze[i].avgResponseTime)
                                }
                                break
                            case 'repairTime':
                                option.legend = {
                                    show: true,
                                    data: ['系统记录维修时长'],
                                    selected: {
                                        '维修次数': false,
                                        '响应时长': false,
                                        '平均响应时长': false,
                                        '系统记录维修时长': true,
                                        '故障总时长': false,
                                        // '两小时修复率': false,
                                        'MTBF': false,
                                        'MTTR': false
                                    }
                                }
                                option.series = [{ name: '系统记录维修时长', type: 'bar', data: [] }]
                                for (var i = 0; i < self.twoAnalyze.length; i++) {
                                    option.xAxis[0].data.push(self.twoAnalyze[i].andonRespUserName)
                                    option.series[0].data.push(self.twoAnalyze[i].mainResponseTime)
                                }
                                break
                            case 'probTime':
                                option.legend = {
                                    show: true,
                                    data: ['故障总时长'],
                                    selected: {
                                        '维修次数': false,
                                        '响应时长': false,
                                        '平均响应时长': false,
                                        '系统记录维修时长': false,
                                        '故障总时长': true,
                                        // '两小时修复率': false,
                                        'MTBF': false,
                                        'MTTR': false
                                    }
                                }
                                option.series = [{ name: '故障总时长', type: 'bar', data: [] }]
                                for (var i = 0; i < self.twoAnalyze.length; i++) {
                                    option.xAxis[0].data.push(self.twoAnalyze[i].andonRespUserName)
                                    option.series[0].data.push(self.twoAnalyze[i].toFResponseTime)
                                }
                                break
                            /*case 'twoRate':
                            option.legend = {
                                show: true,
                                data: ['两小时修复率'],
                                selected: {
                                    '维修次数': false,
                                    '响应时长': false,
                                    '平均响应时长': false,
                                    '系统记录维修时长': false,
                                    '故障总时长': false,
                                    '两小时修复率': true,
                                    'MTBF': false,
                                    'MTTR': false
                                }
                            }
                            option.series = [{ name: '两小时修复率', type: 'bar', data: [] }]
                            for (var i = 0; i < self.twoAnalyze.length; i++) {
                                option.xAxis[0].data.push(self.twoAnalyze[i].devCode + '(' + self.twoAnalyze[i].devName + ')')
                                option.series[0].data.push(self.twoAnalyze[i].recoveryCount != null ? String(parseFloat(self.twoAnalyze[i].recoveryCount / self.twoAnalyze[i].sumCount)).substring(0, String(parseFloat(self.twoAnalyze[i].recoveryCount / self.twoAnalyze[i].sumCount)).indexOf('.') + 3) : '0')
                            }
                            break*/
                            case 'MTBF':
                                option.legend = {
                                    show: true,
                                    data: ['MTBF'],
                                    selected: {
                                        '维修次数': false,
                                        '响应时长': false,
                                        '平均响应时长': false,
                                        '系统记录维修时长': false,
                                        '故障总时长': false,
                                        // '两小时修复率': false,
                                        'MTBF': true,
                                        'MTTR': false
                                    }
                                }
                                option.series = [{ name: 'MTBF', type: 'bar', data: [] }]
                                for (var i = 0; i < self.twoAnalyze.length; i++) {
                                    option.xAxis[0].data.push(self.twoAnalyze[i].andonRespUserName)
                                    option.series[5].data.push(self.twoAnalyze[i].mtbf)
                                }
                                break
                            case 'MTTR':
                                option.legend = {
                                    show: true,
                                    data: ['MTTR'],
                                    selected: {
                                        '维修次数': false,
                                        '响应时长': false,
                                        '平均响应时长': false,
                                        '系统记录维修时长': false,
                                        '故障总时长': false,
                                        // '两小时修复率': false,
                                        'MTBF': false,
                                        'MTTR': true
                                    }
                                }
                                option.series = [{ name: 'MTBF', type: 'bar', data: [] }]
                                for (var i = 0; i < self.twoAnalyze.length; i++) {
                                    option.xAxis[0].data.push(self.twoAnalyze[i].andonRespUserName)
                                    option.series[6].data.push(self.twoAnalyze[i].mttr)
                                }
                                break
                            default:
                                option.legend = {
                                    show: true,
                                    data: ['维修次数', '响应时长', '平均响应时长', '系统记录维修时长', '故障总时长'/*, '两小时修复率'*/ /*'MTBF', 'MTTR'*/],
                                    selected: {
                                        '维修次数': true,
                                        '响应时长': true,
                                        '平均响应时长': true,
                                        '系统记录维修时长': true,
                                        '故障总时长': true
                                        // '两小时修复率': true,
                                        // 'MTBF': true,
                                        // 'MTTR': true
                                    }
                                }
                                option.series = [
                                    { name: '维修次数', type: 'bar', data: [] },
                                    { name: '响应时长', type: 'bar', data: [] },
                                    { name: '平均响应时长', type: 'bar', data: [] },
                                    { name: '系统记录维修时长', type: 'bar', data: [] },
                                    { name: '故障总时长', type: 'bar', data: [] }
                                    // { name: '两小时修复率', type: 'bar', data: [] },
                                    // { name: 'MTBF', type: 'bar', data: [] },
                                    // { name: 'MTTR', type: 'bar', data: [] }
                                ]
                                for (var i = 0; i < self.twoAnalyze.length; i++) {
                                    option.xAxis[0].data.push(self.twoAnalyze[i].andonRespUserName)
                                    option.series[0].data.push(self.twoAnalyze[i].sumCount)
                                    option.series[1].data.push(self.twoAnalyze[i].responseTime)
                                    option.series[2].data.push(self.twoAnalyze[i].avgResponseTime)
                                    option.series[3].data.push(self.twoAnalyze[i].mainResponseTime)
                                    option.series[4].data.push(self.twoAnalyze[i].toFResponseTime)
                                    // option.series[5].data.push(self.twoAnalyze[i].recoveryCount != null ? String((parseFloat(self.twoAnalyze[i].recoveryCount / self.twoAnalyze[i].sumCount) * 100).toFixed(2)) + '%' : '0')
                                    // option.series[5].data.push(self.twoAnalyze[i].mtbf)
                                    // option.series[6].data.push(self.twoAnalyze[i].mttr)
                                }
                        }
                    }
                    self.drawLine(option)
                })

            },
            drawLine(option) {
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('main'))
                // 绘制图表
                myChart.setOption(option)
            },
            creatObject: function() {
                var option = {
                    title: { text: '人员统计' },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    toolbox: {
                        show: true,
                        orient: 'vertical',
                        x: 'right',
                        y: 'center',
                        feature: {
                            mark: { show: true },
                            dataView: { show: true, readOnly: false },
                            magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                            restore: { show: true },
                            saveAsImage: { show: true }
                        }
                    },
                    grid: {
                        left: '10%',
                        bottom: '35%'
                    },
                    calculable: true,
                    xAxis: [{
                        type: 'category',
                        data: [],
                        axisLabel: {
                            interval: 0,//横轴信息全部显示
                            rotate: 40//-30度角倾斜显示
                        }
                    }],
                    yAxis: [{
                        type: 'value'
                    }]
                }
                return option
            },
            DeviceExcel: function() {
                this.excelData = []
                for (var i = 0; i < this.twoAnalyze.length; i++) {
                    var orders = this.twoAnalyze[i]
                    var data = {
                        andonRespUserName: orders.andonRespUserName,
                        sumCount: orders.sumCount,
                        responseTime: orders.responseTime != null ? String(parseFloat(orders.responseTime) / 60).substring(0, String(parseFloat(orders.responseTime) / 60).indexOf('.') + 3) : '0',
                        avgResponseTime: orders.responseTime != null ? String(parseFloat(orders.responseTime) / 60 / (orders.sumCount)).substring(0, String(parseFloat(orders.responseTime) / 60 / (orders.sumCount)).indexOf('.') + 3) : '0',
                        repairTime: String(parseFloat(orders.repairTime) / 60).substring(0, String(parseFloat(orders.repairTime) / 60).indexOf('.') + 3),
                        probTime: String(parseFloat(orders.probTime) / 60).substring(0, String(parseFloat(orders.probTime) / 60).indexOf('.') + 3),
                        // twoRate: orders.recoveryCount != null ? String(parseFloat(orders.recoveryCount / orders.sumCount)).substring(0, String(parseFloat(orders.recoveryCount / orders.sumCount)).indexOf('.') + 3) : '0',
                        MTBF: String(parseFloat(orders.totalTime) / 60 / (orders.sumCount)).substring(0, String(parseFloat(orders.totalTime) / 60 / (orders.sumCount)).indexOf('.') + 3),
                        MTTR: String(parseFloat(orders.repairTime) / 60 / (orders.sumCount)).substring(0, String(parseFloat(orders.repairTime) / 60 / (orders.sumCount)).indexOf('.') + 3)
                    }
                    this.excelData.push(data)
                }
                this.DeviceExport()
            },
            formatJson: function(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            DeviceExport: function() {
                const tHeader = ['维修人', '角色', '次数', '响应时长(时)', '平均响应时长(时)', '系统记录维修时长(时)',
                    '故障总时长(时)', 'MTBF', 'MTTR']
                const filterVal = ['andonRespUserName', 'roleName', 'sumCount', 'responseTime', 'avgResponseTime', 'repairTime', 'probTime', 'MTBF', 'MTTR'
                ]
                export_json_to_excel(tHeader, this.formatJson(filterVal, this.excelData), '人员报修统计')
            }

        }
    }
</script>
<style lang="scss" scoped>
    #main {
        width: 1200px;
        height: 700px;
    }

    .box-card {
        // width: 70%;
    }

    #mytable {
        border: 1px solid #e2e5e6;
        padding: 0;
        margin: 0;
        border-collapse: collapse;
    }

    table {
        width: 100%;
    }

    th {
        width: 5vw;
        height: 3vw;
        border-bottom: 1px solid #e2e5e6;
        background-color: #eef3ff;
    }

    td {
        border-right: 1px solid #e2e5e6;
        border-bottom: none;
        font-size: 11px;
        padding: 6px 6px 6px 12px;
        color: #2f6b72;
    }

    td.alt {
        background: #f5fafa;
        color: #797268;
    }
</style>
